export default __webpack_public_path__ + "static/media/psychedelic-therapy.4346fb9e.jpg";